import "../scss/style.scss";
import "photoswipe/dist/photoswipe.css";

// Header component
import "./parts/header/header";

// Preloader component
import "./parts/preloader";

// Breadcrumb component
import "./parts/breadcrumb";

// Hero Banner pattern
import "./patterns/heroBanner";

// Home Page
import "./pages/home";

// References Page
import "./pages/references";

// Franchise Request Page
import "./pages/franchise";

// Single Reference Page
import "./pages/singleReference";

// Projects Page
import "./pages/projects";

// Contact Page
import "./pages/contact";

// Login or Signup Page
import "./pages/loginOrSignup/loginOrSignup";

// Shop / Products Page
import "./pages/products/products";

// Single Product Page
import "./pages/singleProduct/singleProduct";

// Cart Page
import "./pages/cart/cart";

// Checkout Page
import "./pages/checkout";

// My Account Page
import "./pages/myAccount";

// Password Reset Emailing Page
import "./pages/passwordReset";

// Set New Password Page
import "./pages/setNewPassword";

// Favorites Page
import "./pages/favorites/favorites";

// Payment Response Page
import "./pages/paymentResponse";

//Footer component
import "./parts/footer";

import { initAuthCheck } from "./utils/auth";

document.addEventListener("DOMContentLoaded", () => {
  initAuthCheck();
});

import "./pixelTracking";
